import { GET_CLASSIFICATIONS_LIST, STOP_LOADING, ERROR, DELETE_CLASSIFICATION, CREATE_CLASSIFICATION, EDIT_CLASSIFICATION, START_LOADING } from "../ClassificationsAcction/types.js";


const INITIAL_STATE = {
  loading: false,
  success: false,
  message_valid: false
}

export default function (state = INITIAL_STATE, action) {

  switch (action.type) {
    case GET_CLASSIFICATIONS_LIST:
      return {
        ...state,
        classifications_list: action.payload,
        loading: false,
        success: false
      }
    case START_LOADING:
      return {
        ...state,
        loading: true
      }
    case CREATE_CLASSIFICATION:
      return {
        ...state,
        new_classification: action.payload,
        loading: false
      }
    case EDIT_CLASSIFICATION:
      return {
        ...state,
        edited_classification: action.payload,
        loading: false
      }
    case DELETE_CLASSIFICATION:
      return {
        ...state,
        success: true,
        loading: false
      }
    case ERROR:
      return {
        ...state,
        error_message: action.payload,
        message_valid: !state.message_valid,
        loading: false
      }

    case STOP_LOADING:
      return {
        ...state,
        loading: false
      }
    default:
      return {
        ...state
      }
  }
}